import '../config'
import '@babel/polyfill'
import './helpers/polyfills'
import './styles/app.scss'
import 'font-awesome/css/font-awesome.min.css'
import 'regenerator-runtime/runtime'

import React from 'react'
import { render } from 'react-dom'
import TagManager from 'react-gtm-module'

import TiktokPixel from 'tiktok-pixel'
import * as config from 'config'

import { MainRouter } from './router/router'
import { content } from '../config'
import { loadFacebookPixel, loadHandTalk } from './helpers'

const { TOKEN_HANDTALK, META_PIXEL, TIKTOK_PIXEL } = content
const { BRAND, GOOGLE_TAG_MANAGER } = process.env.ENV_VALUES

const tagManagerArgs = {
	gtmId: GOOGLE_TAG_MANAGER
}

TagManager.initialize(tagManagerArgs)
TiktokPixel.init(TIKTOK_PIXEL)

loadHandTalk(TOKEN_HANDTALK)
loadFacebookPixel(META_PIXEL)

function setFavicon(faviconUrl) {
	const link = document.createElement('link')
	link.rel = 'shortcut icon'
	link.href = faviconUrl

	document.getElementsByTagName('head')[0].appendChild(link)
}

setFavicon(`/assets/favicons/${BRAND}-favicon.ico`)

if (window.OneSignal !== undefined && config.oneSignalAppId) {
	var OneSignal = window.OneSignal || []
	OneSignal.push(function() {
		OneSignal.init({
			appId: config.oneSignalAppId
		})
	})
}

render(<MainRouter />, document.getElementById('root'))
